const NUMBER_MONTH_DECREMENT = 1;
/**
 * Convert to Date format
 * @param {string} date - Date string ISO format.
 * @param {string} type - Date format (pt, en).
 * @returns en { year,month,day } pr {day,month,year}
 */
const convertDate = (date, type) => {
  const dataRegex = type === 'en'
    ? /(?<year>[0-9]{4})-(?<month>[0-9]{2})-(?<day>[0-9]{2})/
    : /(?<day>[0-9]{2})\/(?<month>[0-9]{2})\/(?<year>[0-9]{4})/;

  const { groups } = dataRegex.exec(date);
  return groups;
};

/**
 * Convert to Date format
 * @param {string} date - Date string ISO format.
 * @returns year,month,day,hour,minute,second
 */
const convertDateTime = (date) => {
  const dateTimeRegex = /(?<year>[0-9]{4})-(?<month>[0-9]{2})-(?<day>[0-9]{2})T(?<hour>[0-9]{2}):(?<minute>[0-9]{2}):(?<second>[0-9]{2})/;

  const { groups } = dateTimeRegex.exec(date);
  return groups;
};

/** date as string */
const formatDate = (date, format = 'pt', type = 'en') => {
  const { year, month, day } = convertDate(date, type);

  const dates = {
    en: {
      date: `${year}-${month}-${day}`,
      fullDate: new Date(year, Number(month) - NUMBER_MONTH_DECREMENT, day),
    },
    pt: {
      date: `${day}/${month}/${year}`,
      fullDate: new Date(year, Number(month) - NUMBER_MONTH_DECREMENT, day),
    },
  };

  return dates[format];
};

const formatDateTime = (date, format = 'pt', type = 'en') => {
  const {
    year, month, day, hour, minute, second,
  } = convertDateTime(date);

  const dates = {
    en: {
      date: `${year}-${month}-${day} ${hour}:${minute}:${second}`,
      fullDate: new Date(year, Number(month) - NUMBER_MONTH_DECREMENT, day, hour, minute, second),
    },
    pt: {
      date: `${day}/${month}/${year} ${hour}:${minute}:${second}`,
      fullDate: new Date(year, Number(month) - NUMBER_MONTH_DECREMENT, day, hour, minute, second),
    },
  };

  return dates[format];

  // return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
};

export default {
  formatDate,
  formatDateTime,
};
